<template>
    <select v-model="model" class="form-control">
        <option v-if="placeholder" v-bind:value="undefined">{{placeholder}}</option>

        <option v-for="option in mappedOptions"
                :key="option.value"
                v-bind:value="option.value"
        >
            {{option.text}}
        </option>
    </select>
</template>

<script>
    export default {
        name: "dropdown",
        computed: {
            mappedOptions(){
                const vm = this;

                if(vm.valueField){
                    const valueField = vm.valueField;
                    const textField = vm.textField || vm.valueField;

                    return vm.options.map(o => ({ value: o[valueField], text: o[textField] }));
                }

                //Simply use our input options for display/value
                return vm.options.map(o => ({ value: o, text: o }));
            },
            model: {
                get(){
                    return this.value;
                },
                set(value){
                    this.$emit('input', value);
                }
            }
        },
        props: {
            options: Array,
            placeholder: String,
            value: undefined,
            
            textField: {
                type: String,
                default: ''
            },
            valueField: {
                type: String,
                default: ''
            }
        }
    }
</script>
